import LojasLista from "@/pages/lojas/LojasLista";

export default [
  {
    path: "/sistema/lojas",
    name: "LojasLista",
    component: LojasLista,
    meta: { permissao: "lojas:acessar" },
  },
];
